<template>
    <div>

        <div v-if="loading">
            <div id="controls"></div>
            Loading ...
        </div>
        <div v-else>
            <!-- Display props error -->
            <div v-if='propsError'>
                <div v-for='error in errors' :key='error' class='text-danger'>{{ error }}</div>
            </div>

            <!-- If dont have eny error -->
            <div v-else>
                <div class="mt-3" style="display: block;">
                    <h4>{{ bank }}</h4>

                    <button :disabled='disabled' class="btn btn-lg btn-primary btn-block mt-2 submitMonetawebReq" @click='submit'>Submit</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Sofort',
  props: {
    return_url: String,
    bank: String,
    amount: String,
    token: String,
    data: String,
    submitForm: Boolean
    },
    data: function() {
      return {
      propsError:false,
      errors: [],
      disabled: false,
      clicked: false,
      loading: false
  };
    },
    created(){
        // when clicked change value and excecute watch for clicked
        this.clicked = !this.clicked;

        // return error if is any error in prop
        if( !this.$props.return_url ){
            this.errors.push('Return Url prop is required')
            this.propsError = true
        }
        if( !this.$props.amount ){
            this.errors.push('Amount prop is required')
            this.propsError = true
        }
        if( isNaN(this.$props.amount) ){
            this.errors.push('Amount prop need to be number in format 5.99 or 10')
            this.propsError = true
        }
        if( this.$props.amount.toString().split('.')[1] ){
            if( this.$props.amount.toString().split('.')[1].length > 2 ){
                this.errors.push('Amount prop need to be number in format 5.99 or 10')
                this.propsError = true
            }
        }
        if( this.$props.amount < 0.05 ) {
            this.errors.push('The amount must be at least 0.05.')
            this.propsError = true
        }
        if( !this.$props.bank ){
            this.errors.push('Bank prop is required')
            this.propsError = true
        }
        if( !this.$props.token ){
            this.errors.push('Token missing')
            this.propsError = true
        }

    },
    methods: {
        submit: function() {
            if (!this.propsError) {
                var self = this;
                this.disabled = true

                axios.post('https://gtn-gateway.draft2017.com/api/v2/orders',{
                    amount: this.$props.amount,
                    method: this.$props.bank.toLowerCase(),
                    return_url: this.$props.return_url
                },
                {
                    headers: {'Authorization': 'Bearer ' + this.$props.token}
                },
                )
                .then(response => (
                     window.location.href = response.data.redirect_url,
                     this.disabled = false
                  )
                )
                .catch(function (error) {
                    // handle error
                    self.errors.push(error.response.data.message)

                    // handle specific errors
                    if(error.response.data.errors.return_url) {
                        self.errors.push(error.response.data.errors.return_url[0])
                    }
                    if(error.response.data.errors.amount) {
                        self.errors.push(error.response.data.errors.amount[0])
                    }

                    self.propsError = true
                    self.disabled = false
                });
            }
        }
    },
    watch: {
        clicked: function () {
            if (this.$props.data) {
                let object = JSON.parse(this.$props.data);

                if ( object.method ) {
                    if ( object.method.toUpperCase() == this.$props.bank ) {
                        // autosubmit
                        // if in props json data field autoSubmit is true
                        if( object.autoSubmit ) {
                            if (this.$props.submitForm) {
                                this.submit();
                            }
                        }
                    }
                }
            }
        },
        submitForm: function (value) {
            if (this.$props.data) {
                let object = JSON.parse(this.$props.data);

                if ( object.method ) {
                    if ( object.method.toUpperCase() == this.$props.bank ) {

                        // autosubmit
                        // if in props json data field autoSubmit is true
                        if( object.autoSubmit ) {
                            if (value) {
                                this.submit();
                                if (!this.propsError) {
                                    this.loading = true;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
